import { useStylesHook } from "../hooks/useStylesHook";
import { calculateDimension } from "../styling/dimensions.styles";
export function useFlexStyles(props) {
    var _a, _b, _c;
    return useStylesHook({
        flex: {
            display: "flex",
            flexDirection: (_a = props === null || props === void 0 ? void 0 : props.direction) !== null && _a !== void 0 ? _a : {},
            gap: calculateDimension(props === null || props === void 0 ? void 0 : props.gap),
            alignItems: (_b = props === null || props === void 0 ? void 0 : props.alignItems) !== null && _b !== void 0 ? _b : {},
            justifyContent: (_c = props === null || props === void 0 ? void 0 : props.justifyContent) !== null && _c !== void 0 ? _c : {},
            flexWrap: (props === null || props === void 0 ? void 0 : props.wrap) ? "wrap" : {},
        },
    });
}
